import { TUser } from '@/services/user';
import { useQueryClient } from '@tanstack/react-query';

const useGetUserFromCache = () => {
  const queryClient = useQueryClient();
  return queryClient.getQueryData<TUser>(['user']);
};

export default useGetUserFromCache;
